import { COLS, ROWS } from './constants.js';
import type { GameState } from './types.js';

export const state: GameState = {
  grid: new Uint8Array(COLS * ROWS),
  player: {
    x: 0, y: 0,
    dir: null,
    queuedDir: null,
    drawing: false,
    dashTicks: 0,
  },
  enemies: [],
  floorEnemies: [],
  particles: [],
  pickups: [],
  inventory: { freeze: 0, dash: 0, shield: 0, slowmo: 0 },
  claimEchoes: [],
  globalSlowMs: 0,
  stepPulse: 99,
  shake: 0,
  level: 1,
  worldIdx: 0,
  lives: 3,
  score: 0,
  hiScore: 0,
  claimedPct: 0,
  running: false,
  paused: false,
  dead: false,
  invuln: 0,
  trailCells: [],
  freezeTicks: 0,
  slowmoTicks: 0,
  shield: false,
  combo: 1,
  comboTimer: 0,
  comboMaxThisLevel: 1,
  finished: false,
  sfxVolume: 0.8,
  musicVolume: 0.5,
  runClientSeed: '',
  runStartedAt: 0,
  runPerfectClears: 0,
  runComboPeak: 0,
  runWorldScores: { synthwave: 0, biosphere: 0, glacial: 0, inferno: 0, void: 0 },
  runScoreAtWorldStart: 0,
  runLevelSplits: [],
  runNoPowerupsSoFar: true,
  runDailySeed: null,
  runElapsedMs: 0,
  streamerMode: false,
  godmode: false,
};

export const idx = (x: number, y: number): number => y * COLS + x;

export const inBounds = (x: number, y: number): boolean =>
  x >= 0 && y >= 0 && x < COLS && y < ROWS;
